import { useDataTableContext } from "pages/gdt/store/DataTableProvider";
import { ButtonIconPlainPermissioned } from "pages/gdt/plain/ButtonIconPlain";
import { DATA_TABLE_TOOLTIP_ID } from "../DataTableTooltip";
import { useState } from "react";
import { ModalDeleteRows } from "pages/gdt/modals/ModalDeleteRows";

interface QuickActionDeleteRowBaseProps {
  tableId: string;
  rowIds: string[];
  tooltipContent: string;
  isDisabled: boolean;
  id: string;
}

const QuickActionDeleteRowBase = ({
  tableId,
  rowIds,
  tooltipContent,
  isDisabled,
  id,
}: QuickActionDeleteRowBaseProps) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <>
      {isModalOpen && (
        <ModalDeleteRows
          tableId={tableId}
          rowIds={rowIds}
          onClose={() => setIsModalOpen(false)}
        />
      )}
      <ButtonIconPlainPermissioned
        requiredPermission="edit"
        aria-label={tooltipContent}
        data-tooltip-id={DATA_TABLE_TOOLTIP_ID}
        data-tooltip-content={tooltipContent}
        iconSize="m"
        iconType="minusInCircle"
        color="danger"
        onClick={() => setIsModalOpen(true)}
        disabled={isDisabled}
        id={id}
      />
    </>
  );
};

interface QuickActionDeleteRowProps {
  tableId: string;
  rowId: string;
}

export const QuickActionDeleteRow = ({
  tableId,
  rowId,
}: QuickActionDeleteRowProps) => {
  return (
    <QuickActionDeleteRowBase
      tooltipContent="Delete row"
      tableId={tableId}
      rowIds={[rowId]}
      isDisabled={false}
      id={"quickActionDeleteRow"}
    />
  );
};

export const QuickActionDeleteSelectedRows = () => {
  const selectedTableId = useDataTableContext((s) => s.selectedTableId);
  const selectedRowIds = useDataTableContext((s) => s.selectedRowIds);

  if (selectedTableId === undefined) {
    return null;
  }

  return (
    <QuickActionDeleteRowBase
      tooltipContent={
        selectedRowIds.length > 1
          ? `Delete ${selectedRowIds.length} selected rows`
          : "Delete selected row"
      }
      tableId={selectedTableId}
      rowIds={selectedRowIds}
      isDisabled={selectedRowIds.length === 0}
      id={"quickActionDeleteSelectedRows"}
    />
  );
};
